'use client';

import { Divider } from '@mui/material';
import clsx from 'clsx';
import { Fragment } from 'react';
import { RiCheckDoubleLine, RiCheckLine, RiErrorWarningLine, RiTimeLine } from 'react-icons/ri';

/** Colors follow CustomTooltip's inverted surface (--color-tooltip / --color-tooltip-foreground). */
export const tooltipFg = 'var(--color-tooltip-foreground)';
export const tooltipFgMuted = 'color-mix(in srgb, var(--color-tooltip-foreground) 60%, transparent)';
export const formatEventTimestamp = ts => {
  if (!ts) return '';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '';
  const day = d.getDate();
  const month = d.toLocaleString('en-US', {
    month: 'long'
  });
  const year = d.getFullYear();
  const time = d.toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  return ` at ${day} ${month} ${year} ${time}`;
};

/** Delivery-style tick icon for event statuses (delivered/sent/queued/failed/bounced). */
export const eventTickIcon = status => {
  const s = status?.toLowerCase();
  if (s === 'delivered') return <RiCheckDoubleLine style={{
    fontSize: '0.875rem',
    color: '#16a34a',
    flexShrink: 0
  }} />;
  if (s === 'sent') return <RiCheckDoubleLine style={{
    fontSize: '0.875rem',
    color: '#6b7280',
    flexShrink: 0
  }} />;
  if (s === 'queued') return <RiCheckLine style={{
    fontSize: '0.875rem',
    color: '#d97706',
    flexShrink: 0
  }} />;
  if (s === 'failed' || s === 'bounced') return <RiErrorWarningLine style={{
    fontSize: '0.875rem',
    color: 'var(--color-red-700)',
    flexShrink: 0
  }} />;
  return <RiTimeLine style={{
    fontSize: '0.875rem',
    color: '#9ca3af',
    flexShrink: 0
  }} />;
};
/** Titled event list for CustomTooltip content ("Delivery Status", "Call History"). */
export const StatusEventList = ({
  title,
  items
}) => <div style={{
  minWidth: 200,
  maxWidth: 290
}}>
        <p className="text-xs font-semibold pt-1.5 pb-1 tracking-wide mb-1.5" style={{
    color: tooltipFg
  }}>
            {title}
        </p>
        <div className="flex flex-col gap-1.5 mb-1">
            {items.map((item, i) => <Fragment key={i}>
                    <div className={clsx('px-3 py-0.5 -mx-3!')}>
                        <div className="flex items-center justify-between gap-2">
                            <div className="flex items-center gap-1.25 min-w-0 flex-1" style={{
            color: i === 0 ? tooltipFg : tooltipFgMuted
          }}>
                                {item.icon}
                                <div className="text-[11px] whitespace-pre-line text-left leading-normal">{item.title}</div>
                            </div>
                            <div className="shrink-0 flex items-center ml-1">{item.tick}</div>
                        </div>
                        {item.detail && <div className="border-l-2 ml-5.25 mt-0.5 pl-2 text-[10px]" style={{
          borderColor: 'color-mix(in srgb, var(--color-tooltip-foreground) 30%, transparent)',
          color: tooltipFgMuted
        }}>
                                {item.detail}
                            </div>}
                    </div>
                    {i < items.length - 1 && <Divider className="-mx-2!" />}
                </Fragment>)}
        </div>
    </div>;